import { instance } from '../../../axios/AxiosInstance';

/** POST `/translation` — body matches `TranslationHandler` (`text`, `from`, `to`). */
export async function translateText(text: string, from: string, to: string[]): Promise<string[]> {
  const { data } = await instance.post<unknown>('translation', { text, from, to });
  if (!Array.isArray(data)) return [];
  return data.map((x) => (typeof x === 'string' ? x : String(x ?? '')));
}
